import type {
  StyleProp,
  ViewStyle,
  Insets,
  Animated as RNAnimated,
} from 'react-native';

export type TabsConfig<T, P = { [key: string]: T }> = {
  [key in keyof P]: T;
};

export interface TabBarConfigurableProps {}

export type BottomTabBarProps<T> = {
  /**
   * Initial index.
   */
  navigationIndex: number;

  /**
   * Callback when item been long pressed.
   */
  handleLongPress?: () => void;

  /**
   * Callback when animated index changes.
   */
  handleIndexChange: (index: number) => void;

  /**
   * Tabs configurations.
   */
  tabs: TabsConfig<T, T>;

  /**
   * Root container style.
   */
  style?:
    | StyleProp<ViewStyle>
    | RNAnimated.WithAnimatedValue<StyleProp<ViewStyle>>;

  /**
   * React Navigation Props
   */
  state?: any;
  navigation?: any;
  descriptors?: any;
  onTabPress?: any;
  onTabLongPress?: any;
  safeAreaInsets?: Insets;
} & Omit<TabBarConfigurableProps, 'onLongPress'>;
